 
import Document from '@tiptap/extension-document'
import Paragraph from '@tiptap/extension-paragraph'
import Text from '@tiptap/extension-text' 
import TextAlign from '@tiptap/extension-text-align'
import Bold from '@tiptap/extension-bold';
import Italic from '@tiptap/extension-italic'
import Link from '@tiptap/extension-link'
import Underline from '@tiptap/extension-underline'
import Strike from '@tiptap/extension-strike'
import { BulletList, OrderedList, ListItem } from '@tiptap/extension-list'
import Image from '@tiptap/extension-image'
import { generateHTML } from '@tiptap/html';
import Heading from '@tiptap/extension-heading'
import { UndoRedo } from '@tiptap/extensions'
import './tiptap_editor.scss'

export const tt_extensions = [
    Document,
    Paragraph,
    Text,
    Bold,
    Italic,
    Strike,
    Underline,
    Link,
    BulletList,
    OrderedList,
    ListItem, 
    UndoRedo,
    Heading.configure({
        levels: [1, 2, 3 ],
      }),
    Image.configure({
        resize: {
            enabled: true,
            alwaysPreserveAspectRatio: true 
        } 
    }),
    TextAlign.configure({
        types: ['heading', 'paragraph'], // Define which nodes can be aligned
        alignments: ['left', 'center', 'right', 'justify'], // Optional: defaults are these 4
        defaultAlignment: 'left',
      }),
]

export const TTJson = ({ ttData }) => <div><h3>TipTap data json</h3><pre style={{whiteSpace: 'pre-wrap', wordWrap: 'break-word', overflowX: 'auto'}}>{ ttData && JSON.stringify(ttData, null, 2)}</pre></div>;
export const TTHtml = ({ ttData }) => <div><h3>TipTap data html</h3><pre style={{whiteSpace: 'pre-wrap', wordWrap: 'break-word', overflowX: 'auto'}}>{ ttData && generateHTML(ttData, tt_extensions )}</pre></div>;
